<template lang="pug">
  .consultation--output-category
    output-fields(
      :fields="fields"
      :indent-size="indentSize"
      :print-customer-pref="printCustomerPref"
      :is-print='isPrint'
      :is-concept-status="isConceptStatus"
      @update="(id, v) => $emit('update', id, v)"
    )

    template(v-for="(building, index) in buildings_")
      v-flex.xs12(:key="building.id")
        h4.primary--text.mt-2.mb-1(:class="`ml-${ indentSize * 4 }`")
          span(:class="isConceptStatus && 'transparent'") Gebäude „{{ building.name }}“

      output-fields(
        :fields="building.fields"
        :indent-size="indentSize + 1"
        :print-customer-pref="printCustomerPref"
        :is-print='isPrint'
        :is-concept-status="isConceptStatus"
        @update="(id, v) => $emit('update', id, v)"
      )

</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({
  // components: {
  //   OutputFields: () => import('./output-fields.vue')
  // }
})
export default class OutputCategory extends Vue {
  @Prop({ type: Array, default: () => [] }) fields
  @Prop({ type: Object, default: () => {} }) buildings
  @Prop({ type: Number, default: 0 }) indentSize
  @Prop({ type: Boolean, default: false }) printCustomerPref
  @Prop({ type: Boolean, default: false }) isPrint
  @Prop({ type: Boolean, default: false }) isConceptStatus

  get buildings_ () {
    return Object.values(this.buildings || {})
      .filter(b => !b.hidden)
      .sort((a, b) => a.sort_index - b.sort_index)
  }
}
</script>

<style lang="sass">
.consultation--output-category
  .col
    padding: 8px 12px

  .field-value
    justify-content: flex-end
    max-width: calc(100% - 100px)

  .attach-next
    max-width: 50%

    & + .field-value
      max-width: 50%

  span.transparent
    opacity: 0

.output-section.vertrag
  .consultation--output-category
    .field-value
      justify-content: flex-start
      max-width: 100%

.output-section.concept
  .consultation--output-category
    .field-value
      max-width: 100%
</style>
